import React from "react";

import RequireAuth from "../RequireAuth.jsx";
import MobileLayout from "../mobile/MobileLayout.jsx";
import propertyRoutes from "./mobile/property.routes.js";

const mobileRoutes = {
  path: "/m",
  element: <RequireAuth />,
  children: [
    {
      element: <MobileLayout />,
      children: [
        propertyRoutes, // 以后继续增加 // financeRoutes, // assetRoutes, // userRoutes,]],
      ],
    },
  ],
};

export default mobileRoutes;
